<template>
    <div>
        <div class="page">
            <div class="vertical-flow">
                <ul class="nav nav-tabs nav-tabs-children">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="listaPermissoes[aba].read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <!-- CONJTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="listaPermissoes[aba].read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <ClienteTabPreco
                    ref="tabClienteTabPreco"
                    v-if="
                        abasAbertas['cliente-tabpreco'] &&
                        listaPermissoes['cliente-tabpreco'].read
                    "
                    v-show="abas[abaSelecionada] == 'cliente-tabpreco'"
                    @isChanged="isChanged = $event"
                />
                
                <ClienteTipoPedido
                    ref="tabClienteTipoPedido"
                    v-if="
                        abasAbertas['cliente-tipopedido'] &&
                        listaPermissoes['cliente-tipopedido'].read
                    "
                    v-show="abas[abaSelecionada] == 'cliente-tipopedido'"
                    @isChanged="isChanged = $event"
                />

                <ClientePrazoPagamento
                    ref="tabClientePrazoPagto"
                    v-if="
                        abasAbertas['cliente-prazopagto'] &&
                        listaPermissoes['cliente-prazopagto'].read
                    "
                    v-show="abas[abaSelecionada] == 'cliente-prazopagto'"
                    @isChanged="isChanged = $event"
                />

                <ClienteFormaPagamento
                    ref="tabClienteFormaPagto"
                    v-if="
                        abasAbertas['cliente-formapagto'] &&
                        listaPermissoes['cliente-formapagto'].read
                    "
                    v-show="abas[abaSelecionada] == 'cliente-formapagto'"
                    @isChanged="isChanged = $event"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

// Abas
import ClienteTabPreco from "@/components/b2b/politica-comercial/abas/relacao-com-cliente/ClienteTabPreco";
import ClienteTipoPedido from "@/components/b2b/politica-comercial/abas/relacao-com-cliente/ClienteTipoPedido";
import B2BEmpresaService from '@/services/b2b/B2BEmpresaService';
import ClienteFormaPagamento from "@/components/b2b/politica-comercial/abas/relacao-com-cliente/ClienteFormaPagamento";
import ClientePrazoPagamento from "@/components/b2b/politica-comercial/abas/relacao-com-cliente/ClientePrazoPagamento";

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        ClienteTabPreco,
        ClienteTipoPedido,
        ClienteFormaPagamento,
        ClientePrazoPagamento
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            abas: [
                "cliente-tabpreco",
                "cliente-tipopedido",
                "cliente-prazopagto",
                "cliente-formapagto"
            ],
            abasAbertas: {},
            permissaoDadosCadastrais: false,
            permissaoPoliticaComercial: false,
            listaPermissoes: {},
            isChanged: false,
            newToEdit: false,
            cliente: null,
            service: new B2BEmpresaService(this.$http, this.$router),
            name: null,
            loadingName: false
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
        if (this.$route.query.dadoscadastrais && this.$route.params.id) {
            this.changeTab(this.$route.query.dadoscadastrais < this.abas.length 
                ? this.$route.query.dadoscadastrais
                : 0
            );
        }
    },
    created() {
        this.permissaoDadosCadastrais = this.hasPermissionAccess(
            "b2b",
            "b2b-politica-comercial-list"
        );

        if (
            !this.permissaoDadosCadastrais.create ||
            !this.permissaoDadosCadastrais.read
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "b2b" },
            });
        } else {
            this.loadName();
            // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    "b2b",
                    `b2b-politica-comercial-list-${value}`
                );
            }

            this.permissaoPoliticaComercial = this.hasPermissionAccess(
                "produtos",
                "produto-politica-comercial"
            );

            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
            this.id = this.$route.params.id;
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        loadName() {
            this.loadingName = true;
            this.service.find(this.$route.params.id)
                .then((res) => {
                    this.name = res.content.rsocial;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.loadingName = false;
                })
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.page {
    position: relative;
    padding-left: 0;

    .nav-tabs-children {
        margin-bottom: 20px;
        li > a {
            text-transform: capitalize;
        }
        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }

    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: "";
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
